import React from 'react';
import * as Cesium from 'cesium';
import { Entity, PolylineGraphics } from 'resium';
function StaticFlightPathEntity({ id, tracked, positions }) {
    const color = tracked ? Cesium.Color.BLUE : Cesium.Color.CYAN;
    return (React.createElement(Entity, { id: id },
        React.createElement(PolylineGraphics, { positions: positions, width: 20, material: new Cesium.PolylineGlowMaterialProperty({ glowPower: 0.1, color }) })));
}
export default React.memo(StaticFlightPathEntity);
